import React, { useEffect, useState } from "react";

import { ChevronUpIcon } from "@heroicons/react/24/outline";
import LoadingSpinner from "../../shared-components/LoadingSpinner";

import { classNames, LONG_TEXT_WRAP_CLASSES } from "../../utils";
import { Link } from "react-router-dom";
import { useGetReportProductReports } from "../../api/ReportsApi";
import { REPORT_TYPES } from "../../api/Reports";

const MisconductLink: React.FC<{ report_uuid: string }> = ({ report_uuid }) => {
  const {
    data: productReports,
    isLoading: productReportsLoading,
    mutate: productReportsGet,
  } = useGetReportProductReports();

  const [showLink, setShowLink] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [linkText, setLinkText] = useState("");
  const [misconductStatus, setMisconductStatus] = useState<string>("");

  useEffect(() => {
    productReportsGet(report_uuid);
  }, [report_uuid, productReportsGet]);

  useEffect(() => {
    if (!productReports || productReports?.length === 0) {
      setShowLink(false);
      setIsExpanded(false);
      setMisconductStatus("");
      return;
    }
    for (const pr of productReports) {
      if (pr.report_type === REPORT_TYPES.THREE_SIXTY) {
        const status = pr.content["misconduct_report"];
        setMisconductStatus(status);

        if (status === "DONE" || status === "in_progress_new_profile") {
          setShowLink(true);
          setIsExpanded(true);
          setLinkText(pr.name);
        } else {
          setShowLink(false);
          setIsExpanded(false);
        }
      }
    }
  }, [productReports, setShowLink, setIsExpanded]);
  return (
    <div className="w-full">
      <div className="bg-white rounded-lg border border-gray-300 shadow-sm overflow-hidden">
        <div className="bg-gray-50 p-4 border-b border-gray-200">
          <div className="flex items-center">
            <div className="flex-shrink-0 mr-4">
              <div className="w-6 h-6 rounded-full flex items-center justify-center text-white text-xs bg-purple-800">
                {showLink ? 1 : 0}
              </div>
            </div>
            <div className="flex-grow min-w-0">
              <h3
                className={classNames(
                  "text-gray-700 font-medium text-base",
                  LONG_TEXT_WRAP_CLASSES
                )}
              >
                Fama Report
              </h3>
            </div>
            {showLink && (
              <ChevronUpIcon
                className={classNames(
                  "w-5 flex-none text-gray-500 cursor-pointer",
                  isExpanded ? "rotate-180" : ""
                )}
                onClick={() => setIsExpanded(!isExpanded)}
              />
            )}
          </div>
        </div>
        {isExpanded && (
          <div className="py-4 flex flex-col gap-4">
            {productReportsLoading ? (
              <div className="flex-grow">
                <LoadingSpinner />
              </div>
            ) : (
              <div
                className={classNames(
                  "text-gray-500 text-xs py-1 px-3",
                  LONG_TEXT_WRAP_CLASSES
                )}
              >
                {misconductStatus === "in_progress_new_profile" ? (
                  <span className="text-gray-400 cursor-not-allowed">
                    {linkText || "Misconduct Report"}
                  </span>
                ) : (
                  <Link
                    to={`/360/${report_uuid}/misconduct-qa`}
                    className="text-blue-600 underline hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {linkText || "Misconduct Report"}
                  </Link>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MisconductLink;
